import { PageType } from '@/types/models'
import { RefinementList } from './types'
import { isLocationPageType } from '../useCases/pageTypeCheck'

const getDefaultRefinementsByPageType = (
  pageType: PageType
): RefinementList => {
  return isLocationPageType(pageType)
    ? { what_we_treat: ['Drug Addiction'] }
    : {}
}

export default getDefaultRefinementsByPageType
